import apiClient from "@repo/ui/lib/apiClient";
import type { ApiResponse } from "@repo/ui/types/apiResponse";
import type { BookingDetails } from "@repo/ui/types/booking";

export const getBookingInstate = async (tabSessionId?: string | null): Promise<BookingDetails> => {
  const response = await apiClient<ApiResponse<BookingDetails>>("/v1/bookings", {
    method: "GET",
    withAuth: true,
    tabSessionId,
    cache: "no-store",
  });

  return response.data;
};
